// extracted by mini-css-extract-plugin
export default {"conversation-time":"MessageBubble_conversation-time__Dv4rg","conversation-text":"MessageBubble_conversation-text__80def","fileContainer":"MessageBubble_fileContainer__2xIII"};